import exhibitors from './exhibitors/fr';
import visitors from './visitors/fr';
import managers from './managers/fr';

export default {
  exhibitors,
  visitors,
  managers,
};
